import { useErrorMessage, toast } from '@sentinel/web-core';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { endpoints } from '@/core/api/endpoints';
import { keys } from '@/core/query/query-keys';

/** The latest notifications are enough for the bell; older ones stay in the database. */
const PAGE = { page: 1, pageSize: 20 };

/** The caller's notifications, kept fresh by the realtime channel (`notification.created`). */
export function useNotifications(enabled: boolean) {
  const queryClient = useQueryClient();
  const errorMessage = useErrorMessage();
  const list = useQuery({
    queryKey: keys.notifications,
    queryFn: () => endpoints.notifications.list(PAGE),
    enabled,
  });
  const refresh = () => queryClient.invalidateQueries({ queryKey: keys.notifications });
  const fail = (error: unknown) => toast('att', errorMessage(error));
  const markRead = useMutation({
    mutationFn: (id: string) => endpoints.notifications.markRead(id),
    onSuccess: refresh,
    onError: fail,
  });
  const markAllRead = useMutation({
    mutationFn: () => endpoints.notifications.markAllRead(),
    onSuccess: refresh,
    onError: fail,
  });
  return { list, markRead, markAllRead };
}
